// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AddressResponse } from './address-response';

// @ts-ignore
import { EncounterTableResponse } from './encounter-table-response';

// @ts-ignore
import { EyeglassLensMeasurementResponse } from './eyeglass-lens-measurement-response';

// @ts-ignore
import { EyeglassLensOrderDetailResponse } from './eyeglass-lens-order-detail-response';

// @ts-ignore
import { FrameColorResponse } from './frame-color-response';

// @ts-ignore
import { FrameSizeResponse } from './frame-size-response';

// @ts-ignore
import { LocationProductForOrderResponse } from './location-product-for-order-response';

// @ts-ignore
import { LocationProductItemForOrderResponse } from './location-product-item-for-order-response';

// @ts-ignore
import { OrderEyeglassPrescriptionResponse } from './order-eyeglass-prescription-response';

// @ts-ignore
import { OrderProcessorConfigResponse } from './order-processor-config-response';

// @ts-ignore
import { OrderProductOptionResponse } from './order-product-option-response';

// @ts-ignore
import { OrderResponse } from './order-response';

// @ts-ignore
import { OrderTwelve84Response } from './order-twelve84-response';

// @ts-ignore
import { OrderVendorResponse } from './order-vendor-response';

// @ts-ignore
import { PatientCommunicationResponse } from './patient-communication-response';

// @ts-ignore
import { PatientNameResponse } from './patient-name-response';

/** See com.rev360.pms.api.controller.order.EyeglassOrderResponse */
/* istanbul ignore next */
@GandalfModel
export class EyeglassOrderResponse extends OrderResponse {

	@GandalfProperty({ designType: OrderProductOptionResponse })
	arCoating!: OrderProductOptionResponse | null;

	@GandalfProperty({ designType: String })
	arCoatingSide!: string | null;

	@GandalfProperty({ designType: String })
	comment!: string | null;

	@GandalfProperty({ designType: Date })
	createdOn!: Date | null;

	@GandalfProperty({ designType: Number })
	density!: number | null;

	@GandalfProperty({ designType: Number })
	distancePd!: number | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	dueDate!: Date | null;

	@GandalfProperty({ designType: OrderProductOptionResponse })
	edgeTreatment!: OrderProductOptionResponse | null;

	@GandalfProperty({ designType: EncounterTableResponse })
	encounter!: EncounterTableResponse | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	estimatedDiscounts!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	estimatedInsuranceBenefit!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	estimatedTaxes!: number | null;

	@GandalfProperty({ designType: String })
	externalFrameSupplierIdentifier!: string | null;

	@GandalfProperty({ designType: String })
	externalFrameSupplierName!: string | null;

	@GandalfProperty({ designType: String })
	externalSupplierIdentifier!: string | null;

	@GandalfProperty({ designType: String })
	externalSupplierName!: string | null;

	@GandalfProperty({ designType: FrameColorResponse })
	frameColor!: FrameColorResponse | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	frameCost!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	frameRemakeCost!: number | null;

	@GandalfProperty({ designType: FrameSizeResponse })
	frameSize!: FrameSizeResponse | null;

	@GandalfProperty({ designType: String })
	instructions!: string | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	lensCost!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	lensRemakeCost!: number | null;

	@GandalfConstantDecorator(constants.OrderLensRequest)
	@GandalfProperty({ designType: constants.OrderLensRequest })
	lensRequest!: constants.OrderLensRequest | null;

	@GandalfProperty({ designType: Number })
	locationId!: number | null;

	@GandalfProperty({ designType: String })
	locationName!: string | null;

	@GandalfProperty({ designType: OrderProductOptionResponse })
	material!: OrderProductOptionResponse | null;

	@GandalfProperty({ designType: OrderProductOptionResponse })
	mirrorCoating!: OrderProductOptionResponse | null;

	@GandalfProperty({ designType: OrderProductOptionResponse })
	mountingType!: OrderProductOptionResponse | null;

	@GandalfProperty({ designType: Number })
	nearPd!: number | null;

	@GandalfProperty({ designType: String })
	notificationComments!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	notificationDate!: Date | null;

	@GandalfProperty({ designType: EyeglassLensOrderDetailResponse })
	odDetail!: EyeglassLensOrderDetailResponse | null;

	@GandalfProperty({ designType: EyeglassLensMeasurementResponse })
	odLensMeasurements!: EyeglassLensMeasurementResponse | null;

	@GandalfProperty({ designType: Boolean })
	onHold!: boolean | null;

	@GandalfConstantDecorator(constants.OrderOpticalCenterType)
	@GandalfProperty({ designType: constants.OrderOpticalCenterType })
	opticalCenterType!: constants.OrderOpticalCenterType | null;

	@GandalfConstantDecorator(constants.OrderFrameIndication)
	@GandalfProperty({ designType: constants.OrderFrameIndication })
	orderFrameIndication!: constants.OrderFrameIndication | null;

	@GandalfProperty({ designType: LocationProductForOrderResponse })
	orderFrameProduct!: LocationProductForOrderResponse | null;

	@GandalfProperty({ designType: LocationProductItemForOrderResponse })
	orderFrameProductItem!: LocationProductItemForOrderResponse | null;

	@GandalfConstantDecorator(constants.OrderFrameSource)
	@GandalfProperty({ designType: constants.OrderFrameSource })
	orderFrameSource!: constants.OrderFrameSource | null;

	@GandalfProperty({ designType: Number })
	orderId!: number | null;

	@GandalfProperty({ designType: Number })
	originalOrderId!: number | null;

	@GandalfConstantDecorator(constants.OriginalOrderReason)
	@GandalfProperty({ designType: constants.OriginalOrderReason })
	originalOrderReason!: constants.OriginalOrderReason | null;

	@GandalfProperty({ designType: EyeglassLensOrderDetailResponse })
	osDetail!: EyeglassLensOrderDetailResponse | null;

	@GandalfProperty({ designType: EyeglassLensMeasurementResponse })
	osLensMeasurements!: EyeglassLensMeasurementResponse | null;

	@GandalfProperty({ designType: OrderProductOptionResponse })
	otherCoating!: OrderProductOptionResponse | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	otherCost!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	otherRemakeCost!: number | null;

	@GandalfProperty({ designType: Number })
	pantoscopicTilt!: number | null;

	@GandalfProperty({ designType: PatientNameResponse })
	patient!: PatientNameResponse | null;

	@GandalfProperty({ designType: PatientCommunicationResponse })
	patientCommunication!: PatientCommunicationResponse | null;

	@GandalfProperty({ designType: Boolean })
	patientNotified!: boolean | null;

	@GandalfProperty({ designType: Number })
	personId!: number | null;

	@GandalfProperty({ designType: OrderProductOptionResponse })
	photochromic!: OrderProductOptionResponse | null;

	@GandalfProperty({ designType: OrderProductOptionResponse })
	polarized!: OrderProductOptionResponse | null;

	@GandalfProperty({ designType: OrderEyeglassPrescriptionResponse })
	prescription!: OrderEyeglassPrescriptionResponse | null;

	@GandalfProperty({ designType: OrderProcessorConfigResponse })
	processor!: OrderProcessorConfigResponse | null;

	@GandalfProperty({ designType: Number })
	quantity!: number | null;

	@GandalfProperty({ designType: OrderProductOptionResponse })
	scratchCoating!: OrderProductOptionResponse | null;

	@GandalfConstantDecorator(constants.OrderSegHeightType)
	@GandalfProperty({ designType: constants.OrderSegHeightType })
	segHeightType!: constants.OrderSegHeightType | null;

	@GandalfProperty({ designType: String })
	shade!: string | null;

	@GandalfProperty({ designType: AddressResponse })
	shipAddress!: AddressResponse | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	shipCost!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	shipRemakeCost!: number | null;

	@GandalfConstantDecorator(constants.OrderShipToType)
	@GandalfProperty({ designType: constants.OrderShipToType })
	shipToType!: constants.OrderShipToType | null;

	@GandalfConstantDecorator(constants.OrderShipmentCompany)
	@GandalfProperty({ designType: constants.OrderShipmentCompany })
	shippingCompany!: constants.OrderShipmentCompany | null;

	@GandalfConstantDecorator(constants.OrderShippingSpeed)
	@GandalfProperty({ designType: constants.OrderShippingSpeed })
	shippingSpeed!: constants.OrderShippingSpeed | null;

	@GandalfProperty({ designType: Number })
	smartflowOrderIdentifier!: number | null;

	@GandalfProperty({ designType: OrderProductOptionResponse })
	specialOption!: OrderProductOptionResponse | null;

	@GandalfConstantDecorator(constants.OrderStatusCode)
	@GandalfProperty({ designType: constants.OrderStatusCode })
	statusCode!: constants.OrderStatusCode | null;

	@GandalfProperty({ designType: Date })
	statusDate!: Date | null;

	@GandalfProperty({ designType: OrderProductOptionResponse })
	thickness!: OrderProductOptionResponse | null;

	@GandalfProperty({ designType: OrderProductOptionResponse })
	tintFactor!: OrderProductOptionResponse | null;

	@GandalfProperty({ designType: OrderProductOptionResponse })
	tintType!: OrderProductOptionResponse | null;

	@GandalfProperty({ designType: String })
	trackingNumber!: string | null;

	@GandalfProperty({ designType: String })
	tray!: string | null;

	@GandalfProperty({ designType: OrderTwelve84Response })
	twelve84Response!: OrderTwelve84Response | null;

	@GandalfConstantDecorator(constants.OrderType)
	@GandalfProperty({ designType: constants.OrderType })
	type!: constants.OrderType | null;

	@GandalfProperty({ designType: OrderProductOptionResponse })
	uvTreatment!: OrderProductOptionResponse | null;

	@GandalfProperty({ designType: OrderVendorResponse })
	vendor!: OrderVendorResponse | null;

	@GandalfProperty({ designType: String })
	vendorOrderIdentifier!: string | null;

	@GandalfProperty({ designType: Number })
	version!: number | null;

	@GandalfProperty({ designType: Number })
	wrapAngle!: number | null;

}
